import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';
import stringHelper from 'js/string-helper';
import cn from 'classnames';
import css from './ListSearchForm.module.scss';

class ListSearchForm extends React.Component {
    static propTypes = {
        searchButtonAriaLabel: PropTypes.string,
        searchInputLabel: PropTypes.string,
        searchInputPlaceholder: PropTypes.string,
        searchParamName: PropTypes.string,
        defaultValue: PropTypes.string,
        isLoading: PropTypes.bool,
        totalListItemsCount: PropTypes.number,
        listItemsCount: PropTypes.number,
        searchHitsText: PropTypes.string,
        noResultsText: PropTypes.string,
        noSearchHitsTextDisplayed: PropTypes.bool,
        onFormSubmit: PropTypes.func,
        className: PropTypes.string
    };

    static defaultProps = {
        theme: 0,
        onFormSubmit: () => {}
    };

    state = {
        searchQuery: this.props.defaultValue || ''
    };

    componentDidUpdate(prevProps) {
        if (prevProps.defaultValue !== this.props.defaultValue) {
            this.setState({ searchQuery: this.props.defaultValue || '' });
        }
    }

    handleInputChange = (e) => {
        this.setState({ searchQuery: e.target.value });
    };

    handleFormSubmit = (e) => {
        e.preventDefault();
        this.props.onFormSubmit(this.state.searchQuery);
    };

    render() {
        const {
            searchInputLabel,
            searchButtonAriaLabel,
            searchInputPlaceholder,
            searchParamName,
            isLoading,
            totalListItemsCount,
            listItemsCount,
            searchHitsText,
            noResultsText,
            noSearchHitsTextDisplayed,
            className
        } = this.props;

        const { searchQuery } = this.state;

        return (
            <form 
                onSubmit={this.handleFormSubmit}
                role="search"
            >
                <div className={cn(css.search, className)}>
                    <label className={css.label} htmlFor="searchInput" tabIndex="-1">{searchInputLabel}</label>
                    <div className={css.container}>
                        <input 
                            type="search" 
                            name={searchParamName}
                            placeholder={searchInputPlaceholder} 
                            className={css.input} 
                            id="searchInput" 
                            value={searchQuery} 
                            onChange={this.handleInputChange} 
                        />
                        <button 
                            className={css.button} 
                            aria-label={searchButtonAriaLabel} 
                            disabled={isLoading}
                        >
                            <Icon icon="search" className={css.icon} />
                        </button>
                    </div>
                    <p className={css['search-result-text']}>
                        {noSearchHitsTextDisplayed ? null : (
                            (
                                listItemsCount > 0 ? 
                                    stringHelper.format(searchHitsText, totalListItemsCount) : 
                                    noResultsText
                            )
                        )}
                    </p>
                </div>
            </form>
        );
    }
}

export default ListSearchForm;



// WEBPACK FOOTER //
// ./src/components/ListSearchForm/ListSearchForm.jsx